var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('th',{attrs:{"colspan":_vm.colspan}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n    "),(_vm.data.id)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('editBilling', _vm.data)}}},[_vm._v("("+_vm._s(_vm.data.name)+")")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }